
/**
 * Utility class that provides a method for detecting double, triple or whatever clicks using configurable click interval and move distance
 * thresholds.
 */
export class MultiClickRecognizer {

    private lastButton: number = -1;
    private lastX: number = -1;
    private lastY: number = -1;
    private lastTime: number = -1;
    private count: number = 0;

    constructor(private specificButton?: number) {
    }

    /**
     * Defines how far in pixels the mouse can move during a valid double click.
     */
    public distanceThreshold = 4;

    /**
     * Defines the maximum length of time between clicks to judge a double click.
     */
    public intervalThreshold = 500;

    /**
     * Analyzes the specified MouseInput and returns a value indicating whether or not it is a recognized double click event.  This
     * mechanism requires at least two MouseInputs to be passed in sequence to return true.
     *
     * @param e the mouse input
     */
    public next(e: MouseEvent): number {

        const t = performance.now();
        let continuing = false;

        if (this.lastButton >= 0 && this.lastTime >= 0) {

            const interval = t - this.lastTime;
            const xDist = Math.abs(e.screenX - this.lastX);
            const yDist = Math.abs(e.screenY - this.lastY);

            continuing = (
                e.button === this.lastButton &&
                e.button === this.specificButton || (this.specificButton === undefined) &&
                interval < this.intervalThreshold &&
                xDist <= this.distanceThreshold &&
                yDist <= this.distanceThreshold
            );
        }

        this.lastButton = e.button;
        this.lastX = e.screenX;
        this.lastY = e.screenY;
        this.lastTime = t;

        if (continuing) {
            this.count++;
        }
        else {
            this.count = 1;
        }

        return this.count;
    }
}
